<template>
  <div>
    <el-checkbox :id="id" v-bind="$attrs" v-on:input="$emit('input', $event)">
      {{ label }}
    </el-checkbox>
    <div v-if="$slots.accessory" class="el-form-item__accessory">
      <slot name="accessory" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputCheckbox',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.el-form-item__accessory {
  padding: 5px 0 5px 25px;
}

.el-checkbox:deep(.el-checkbox__input) {
  vertical-align: top;
  margin-top: 3px;
  white-space: normal;
}
</style>
